const BASE_URL = "/rest/lookup"

let cacheLoad = {}

export const getLookup = (lookup: string) => {    
    return fetch(`${BASE_URL}/${lookup}`).then(res => {
        return res.json()
    });
}
